import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, Icon, List, Input, Badge, Button } from "antd";
import { OrderedMap } from "immutable";
import moment from "moment";
import _debounce from "lodash/debounce";
import keyMirror from "key-mirror";
import { STATE_STATUS } from "../constants";
import "styles/review-invoices.css";

const CARD_LABELS = {
    total_request_invoices: "Total requests",
    total_request_pending_invoices: "Pending requests",
    total_request_verified_invoices: "Approved requests"
};

const CARD_STATUS = {
    total_request_invoices: "",
    total_request_pending_invoices: "PENDING",
    total_request_verified_invoices: "APPROVED"
};

const JOB_STAGES_FOR_REVIEWER = [
    "Review Pending",
    "Review Closed"
];

const JOB_STAGES = new keyMirror({
    "Initialized": null,
    "Pending": null,
    "Processed": null,
    "Review Initialized": null,
    "Review Pending": null,
    "Review Closed": null
});

class ReviewInvoices extends Component {

    state = {
        searchValue: null
    };


    componentDidUpdate() {
        this.updateFilters();
    }


    componentDidMount() {
        this.fetchData();
        this.updateFilters();
    }

    updateFilters() {
        if(this.props.filter.search && this.props.filter.search.length > 0 && (!this.state.searchValue || this.state.searchValue.length == 0)) {
            this.setState({
                searchValue: this.props.filter.search
            });
        }
    }

    fetchData() {
        if (this.props.jobsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchJobs("", "PENDING", 1);
        }
        if (this.props.jobsCount.get("status") === STATE_STATUS.UNFETCHED) {
            this.props.fetchJobsCount();
        }
    }

    search = _debounce(searchString => {
        this.props.fetchJobs(searchString, this.props.filter.status, 1);
    }, 400);

    onSearch = searchString => {
        this.setState({
            searchValue: searchString
        }, () => this.search(this.state.searchValue));
    }


    

    renderHeader = () => {
        return (<Input
            value={this.state.searchValue}
            suffix={null}
            prefix={<Icon style={{ fontSize: "16px", right: "10px" }} theme={"outlined"} type={"search"} />}
            bordered={false}
            onChange={e => this.onSearch(e.target.value)}
            className={"w-100 search-input"}
            placeholder="Search dealers"
        />);
    }

    onJobOpen = _ => {
        if (JOB_STAGES_FOR_REVIEWER.includes(_.stage) || _.stage === JOB_STAGES["Review Initialized"]) {
            this.props.history.push(`/app/companies/invoices/${_.id}`,{
                ...this.props.history.location.state,
                tenorOnUpload: true
            });
             
            return;
        } else {
            return;
        }
    }

    renderListItem = (_) => {
        return (
            <List.Item
                onClick={() => this.onJobOpen(_)}
                className={"w-100 cursor-pointer border-none mb-5 bg-white d-flex flex-row align-items-center justify-content-space-between"}
            >
                <div className={"fb-60"}>
                    <div className={"d-flex flex-row align-items-center"}>
                        <h3 className={"m-0"}>
                            {_.seller_name}
                        </h3>
                        {!JOB_STAGES_FOR_REVIEWER.includes(_.stage) && <Badge
                            className={"ml-05"}
                            key={_.id}
                            count={"New"}
                        />}
                    </div>
                    <span className={"mr-10 cursor-pointer pending-req"} >{_.status}</span>
                    <span style={{ fontWeight: 300, opacity: 0.6 }} className={"mr-5 total-req"}>{moment(_.created_on).format("MMM Do, YYYY")}</span>
                </div>
                <div className={"fb-40 d-flex flex-row align-items-center justify-content-space-between"}>
                    <div>
                        <h3 className={"ml-05 cursor-pointer pending-req m-0"} >{(_.approved_invoices || 0)}</h3>
                        <span style={{ color: "#27AE60" }} className={"ml-05 cursor-pointer pending-req"} >Approved</span>
                    </div>
                    <div>
                        <h3 className={"ml-05 cursor-pointer pending-req m-0"} >{(_.pending_invoices) || 0}</h3>
                        <span style={{ color: "#F2994A" }} className={"ml-05 cursor-pointer pending-req"} >Pending</span>
                    </div>
                    <Icon style={{ fontSize: "16px" }} theme={"outlined"} type={"caret-right"} />
                </div>
            </List.Item>
        );
    };

    onStatusChange = status => this.props.fetchJobs(
        this.props.filter.search,
        status,
        1
    );

    renderCards = () => {
        return (
            <Card header={null} bordered={false} className={"p-0 border-none no-shadow mt-015 review-invoices-card"} style={{ width: "60%" }}>
                {new OrderedMap(this.props.jobsCount.get("data")).map((_, k) =>
                    <div className={this.props.filter.status === CARD_STATUS[k] ? "active-card" : ""} onClick={() => this.onStatusChange(CARD_STATUS[k])} key={k}>
                        <h2 className={"fw-500-m-0"}>{CARD_LABELS[k]}</h2>
                        <span className={k}>{_}</span>
                    </div>
                ).toList().toArray()}
            </Card>
        );
    }

    isLoading() {
        if (
            this.props.jobsStatus === STATE_STATUS.FETCHING ||
            this.props.jobsCount.get("status") === STATE_STATUS.FETCHING
        ) {
            return true;
        }
        return false;
    }
     
    onLoadMore = () => {
        if((this.props.filter.page+1)*20 < this.props.filter.count){
            this.props.fetchJobs(this.props.filter.search, this.props.filter.status, this.props.filter.page+1);
        }
    }
    // this.props.jobsCount.getIn(["data", (new Map(CARD_STATUS).findKey(_ => _ === this.props.filter.status))])

    loadMore = () => {
        return  (
            <div
                style={{
                    textAlign: "center",
                    marginTop: 12,
                    height: 32,
                    lineHeight: "32px",
                }}
            >
                <Button onClick={this.onLoadMore}>loading more</Button>
            </div>
        );
    }

    render() {
        // if () {
        //     return (
        //         <Spin className={"d-flex justify-content-center p-10"} />
        //     );
        // }
        return (
            <div className={"d-flex flex-column align-items-center p-20"}>
                <h1 className={"fw-700-m-0"} style={{ fontSize: "26px" }}>Review Invoices</h1>
                {this.renderCards()}
                <List
                    loading={this.isLoading()}
                    border={false}
                    className={"border-none padd-0"}
                    header={this.renderHeader()}
                    bordered
                    style={{ width: "60%" }}
                    loadMore={this.loadMore()}
                    footer={null}
                    dataSource={this.props.jobs.toList().map(_ => _.get("job")).sort((a, b) => {
                        let aTime = moment(a.created_on);
                        let bTime = moment(b.created_on);
                        if(aTime > bTime) {
                            return -1;
                        } else if(aTime < bTime) {
                            return 1;
                        }
                        return 0;
                    })}
                    renderItem={this.renderListItem} />
            </div>
        );
    }
}

ReviewInvoices.propTypes = {
    fetchJobs: PropTypes.func,
    fetchJobsCount: PropTypes.func,
    jobs: PropTypes.object,
    jobsStatus: PropTypes.string,
    jobsCount: PropTypes.object,
    history: PropTypes.object,
    filter: PropTypes.object
};

export default ReviewInvoices;

// const mapStateToProps = state => {
//     return {
//         allInvoiceJob: state.companyLosProfiles.get("allInvoiceJob"),
//         invoiceCards: state.companyLosProfiles.get("invoiceCards")
//     };
// };

// const mapDispatchToProps = dispatch =>
//     bindActionCreators(
//         {
//             fetchJobs: fetchAllInvoiceJob,
//             fetchJobCount: fetchInvoiceCards,
//             fetchMarkJobPending
//         },
//         dispatch
//     );

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ReviewInvoices);